import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_CYAN } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/sky-high.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Sky High — Elektronomia (NCS). 118.72 BPM progressive house with a
 * four-on-the-floor groove and melodic leads. Mid-tempo lookahead
 * window is comfortable for newcomers stepping up from On & On.
 *
 * Synthesised from the Circles onset analysis. To upgrade with a
 * curated piano-arrangement MIDI, see the header doc on
 * {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}.
 */
export const SKY_HIGH_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'sky-high',
  baseTitle: 'Sky High',
  description:
    "Anthemic progressive house from Elektronomia. Four-on-the-floor groove with melodic leads, charted as a flowing 4-lane melody.",
  difficulty: 2,
  totalBeats: 121,
  palette: PALETTE_CYAN,
  audio: buildBuiltinAudio({
    src: '/audio/circles/sky-high.mp3',
    attribution: '"Sky High" by Elektronomia [NCS Release] - https://ncs.io/SkyHigh',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 121,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.05, minSpacing: 0.5 },
    },
  ],
});
